import React from 'react';
import _ from 'lodash';

import { currencyUtil } from 'modules/layer00';
import { BaseWidget } from 'modules/layer01';
import { Table } from 'iron-forge-react-modules';
import { Typography } from '@mui/material';
import * as dataService from './dataService';
import * as types from './types';



const TableComponent = Table.genTableComponent<types.IColumnId>();



export interface IProps {
  returnAuthorizationId: string;
}

export const FC: React.FC<IProps> = props => {
  const queryTuple = dataService.useQuery(props.returnAuthorizationId);



  const rows = React.useMemo(
    () => _.map(queryTuple.data.lineItems, (lineItem): types.IRow => ({
      id: lineItem.id,
      columnId2Value: {
        refundAmount: {
          type: 'string',
          label: currencyUtil.convertBigCentsToDollars(lineItem.refundAmountCents)
        },
        serialNumber: {
          type: 'string',
          label: lineItem.inventoryNumber
        },
        sku: {
          type: 'string',
          label: lineItem.sku
        }
      }
    })),
    [queryTuple.data.lineItems]
  );

  return (
    <BaseWidget.FC title="Item Receipt">
      {!_.isEmpty(queryTuple.data.lineItems) ? (
        <TableComponent
          rows={rows}
          columns={[
            {
              id: 'sku',
              label: "SKU"
            },
            {
              id: 'serialNumber',
              label: "IMEI/ICCID"
            },
            {
              id: 'refundAmount',
              label: "Refund Amount"
            }
          ]} />
      ) : (
        <Typography>
          Not fulfilled yet
        </Typography>
      )}
    </BaseWidget.FC>
  );
};
